//页面权限
const pagePower = [
	{
		id:0,
		label:"系统设置",
		children:[{
			id:1,
			label:"校区设置"
		},{
			id:2,
			label:"职务权限"
		},{
			id:3,
			label:"等级设置"
		},{
			id:4,
			label:"科目设置"
		}]
	},
	{
		id:5,
		label:"信息管理",
		children:[{
			id:6,
			label:"添加教师",
		},{
			id:7,
			label:"教师列表",
			children:[{
				id:8,
				label:"详细信息"
			},{
				id:9,
				label:"历史信息"
			},{
				id:10,
				label:"修改信息"
			},{
				id:11,
				label:"校区变更"
			},{
				id:12,
				label:"职务变更"
			},{
				id:13,
				label:"科目变更"
			},{
				id:14,
				label:"等级评定"
			},{
				id:15,
				label:"密码重置"
			},{
				id:16,
				label:"办理离职"
			}]
		},{
			id:17,
			label:"我的信息"
		}]
	},
	{
		id:18,
		label:"教师数据",
		children:[{
			id:19,
			label:"课时导入"
		},{
			id:20,
			label:"教师课时"
		},{
			id:21,
			label:"教师测试",
			children:[{
				id:22,
				label:"修改测试"
			},{
				id:23,
				label:"添加测试"
			},{
				id:24,
				label:"锁定测试"
			}]
		},{
			id:25,
			label:"单生累计"
		},{
			id:26,
			label:"教师积分",
			children:[{
				id:27,
				label:"添加积分"
			},{
				id:28,
				label:"使用积分"
			}]
		}]
	},
	{
		id:29,
		label:"数据分析",
		children:[{
			id:30,
			label:"课消概况"
		},{
			id:31,
			label:"课时分布"
		},{
			id:32,
			label:"兼职排名"
		}]
	},
	{
		id:33,
		label:"试题库",
		children:[{
			id:34,
			label:"权限设置",
			children:[{
				id:35,
				label:"修改权限"
			},{
				id:36,
				label:"设置下载数量"
			},{
				id:37,
				label:"添加公立学校"
			},{
				id:38,
				label:"设置考试类型"
			}]
		},{
			id:39,
			label:"试题下载"
		},{
			id:40,
			label:"试题上传"
		}]
	}
]
//数据权限
const dataPower = [
	{
		id:-1,
		label:"信息管理",
		children:[{
			id:0,
			label:"添加教师",
		},{
			id:1,
			label:"教师列表",
		}]
	},
	{
		id:-2,
		label:"教师数据",
		children:[{
			id:2,
			label:"教师课时"
		},{
			id:3,
			label:"教师测试"
		},{
			id:4,
			label:"单生累计"
		},{
			id:5,
			label:"教师积分"
		}]
	},
	{
		id:-3,
		label:"数据分析",
		children:[{
			id:6,
			label:"课消概况"
		},{
			id:7,
			label:"课时分布"
		},{
			id:8,
			label:"兼职排名"
		}]
	},
	{
		id:-4,
		label:"试题库",
		children:[{
			id:9,
			label:"权限设置",
		},{
			id:10,
			label:"试题下载"
		},{
			id:11,
			label:"试题上传"
		}]
	}
]
//最大id
const maxid={
	pagePower:0,
	dataPower:0,
}
//转换函数
function arr2obj(arr,obj,typ){
	arr.forEach(e=>{
		if(e.id>maxid[typ]){
			maxid[typ]=e.id
		}
		obj[e.label]=e.id
		if(e.children){
			arr2obj(e.children,obj,typ)
		}
	})
}
//页面权限id
const powerPage={}
arr2obj(pagePower,powerPage,'pagePower')
//数据权限id
const powerData={}
arr2obj(dataPower,powerData,'dataPower')


export {pagePower,dataPower,powerPage,powerData,maxid}